<template>
  <div class="main">
    <div class="section">
      <div class="container">
        <div class="product-view">
          <div class="grid-imgproduct">
            <div class="img">
              <img class="img-product" :src="product.img" alt="" />
            </div>
            <div class="description">
              <h4>Descripción de Producto</h4>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Consectetur, iure. Iure dolorem, eius accusamus dignissimos
                molestias sunt reiciendis velit commodi quisquam alias omnis
                facere minima, expedita cupiditate nemo ullam nobis.
              </p>
            </div>
          </div>
          <div class="component-sell">
            <div class="info-sell">
              <h1>{{ product.nombre }}</h1>
              <h3>$ {{ product.precio }}</h3>
            </div>
            <n-button type="primary" round block size="lg" @click="agregar(product)">Comprar</n-button>
          </div>
        </div>
        <!-- <div class="row">
            <h2 class="title">Nuestros productos y servicios</h2>
            <div class="grid-filter col-md-12">
              <FilterProducts/>
              <GridProducts />
            </div>
          </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "@/components";
export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      params: this.$route.params,
    };
  },
  methods:{
    agregar(i){
      this.$notify({
          title: 'Producto agregado',
          message: 'Se ha agrecado el producto al carrito de compras',
          type: 'success'
        });
      this.$store.commit("increment", i);
    }
  },
  computed: {
    product() {
      return this.$store.state.Productos.find(
        (producto) => producto.idproducto === this.$route.params.idproducto
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.product-view {
  margin: 30px;
  display: grid;
  grid-template-columns: 1fr 0.5fr;
  .component-sell {
    padding: 50px;
    .info-sell {
      margin-bottom: 20px;
    }
    .button-sell {
      width: 200px;
      height: 50px;
      background-color: #a9d043;
      color: #fff;
      border-radius: 5px;
      justify-items: center;
      align-content: center;
      display: grid;
    }
  }
}
.grid-imgproduct {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1px 1px;
  grid-template-areas:
    "img img"
    "des des";
  .img {
    grid-area: img;
    img {
      width: 250px;
      height: 250px;
    }
  }

  .img-1 {
    width: 200px;
    height: 200px;
    grid-area: img-1;
    img {
      width: 200px;
      height: 200px;
    }
  }

  .img-2 {
    grid-area: img-2;
    img {
      width: 200px;
      height: 200px;
    }
  }
  .description {
    margin-top: 30px;
    grid-area: des;
  }
}
</style>
